import PageBanner from "../../../../src/components/PageBanner";
import Gallery from "../../../../src/components/Gallery";
import * as React from 'react';
export default {
  PageBanner,
  Gallery,
  React
};